export const BONUS_BY_PRODUCT_TABLE_PT_BR = {
	title: "Bonificação por produto",
	filename: "bonus_by_product",
	columns: {
		product: "Produto",
		productCategory: "Categoria do Produto",
		bonusCategory: "Categoria do Produto",
		value: "Bonificação recebida durante o período",
		bonusSpentFromOtherPeriod: "Bonificação recebida em outro período",
		receivedInPeriod: "Recebido no evento",
		receivedInOtherPeriod: "Recebido em outros eventos",
		total: "Total da categoria",
		noCategory: "Sem categoria",
	},
	exportToExcel: "Exportar para Excel",
};

export type BonusByProductTableTranslations = typeof BONUS_BY_PRODUCT_TABLE_PT_BR;
